
export default function Urgency() {
  return (
    <section className="bg-black py-14 relative overflow-hidden">
      <div className="max-w-5xl mx-auto px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
          {/* Left Side */}
          <div className="flex items-center gap-6 lg:w-1/2">
            <div className="w-20 h-20 flex items-center justify-center flex-shrink-0">
              <i className="ri-hourglass-line text-5xl text-[#D4AF37] animate-pulse"></i>
            </div>
            <div>
              <h2 className="text-3xl lg:text-4xl font-bold leading-tight">
                Vagas Limitadas
                <br />
                <span className="text-[#D4AF37]">Nesta Temporada</span>
              </h2>
            </div>
          </div>

          {/* Right Side */}
          <div className="lg:w-1/2 space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-[#D4AF37]/20 rounded-full flex-shrink-0">
                <span className="text-[#D4AF37] font-bold text-base">12</span>
              </div>
              <p className="text-white text-base leading-relaxed">
                Vagas restantes para reservas na alta temporada
              </p>
            </div>

            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-[#D4AF37]/20 rounded-full flex-shrink-0">
                <i className="ri-calendar-check-line text-[#D4AF37] text-lg"></i>
              </div>
              <p className="text-white text-base leading-relaxed">
                A alta temporada é reservada com 2 a 3 meses de antecedência
              </p>
            </div>

            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-[#D4AF37]/20 rounded-full flex-shrink-0">
                <i className="ri-user-star-line text-[#D4AF37] text-lg"></i>
              </div>
              <p className="text-white text-base leading-relaxed">
                Atendimento personalizado significa vagas limitadas por cliente
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Banner */}
        <div className="mt-10 p-4 border border-[#D4AF37] rounded-xl bg-[#D4AF37]/5 backdrop-blur-sm">
          <p className="text-center text-white text-base font-serif italic">
            O calendário da PremierNY para a alta temporada esgota rápido. Garanta sua vaga hoje.
          </p>
        </div>
      </div>
    </section>
  );
}
